// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".chunk." + __webpack_require__.h().slice(0, 8) + ".js";
};